<template>
  <div class="PaB-scroller" :class="{'PaB-scroller--x': direction === 'x', 'PaB-scroller--y': direction === 'y'}">
    <div class="PaB-scroller-overflow" ref="scroller" :style="overflowStyle" @scroll="checkOverflow">
      <slot></slot>
    </div>
    <div class="PaB-scroller-fades">
      <transition name="PaB-scroller-fade">
        <div class="PaB-overflowing-start" v-if="overflowing.start" :style="fadeStartStyle"></div>
      </transition>
      <transition name="PaB-scroller-fade">
        <div class="PaB-overflowing-end" v-if="overflowing.end" :style="fadeEndStyle"></div>
      </transition>
    </div>
    <div class="PaB-scroll-bar" v-if="scrollbar && (overflowing.start || overflowing.end)">
      <div class="PaB-scroll-bar__handle" :style="scrollBarStyle"></div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.PaB-scroller {
  overflow: hidden;
  position: relative;
}
.PaB-scroller-fades {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
  z-index: 9;
}
.PaB-scroller-overflow {
  -webkit-overflow-scrolling: touch;
}

.PaB-scroll-bar {
  background-color: #ddd;
  position: absolute;
  .PaB-scroll-bar__handle {
    position: absolute;
    background-color: #aaa;
  }
}

.PaB-overflowing-start,
.PaB-overflowing-end {
  position: absolute;
  pointer-events: none;
  z-index: 20;
  opacity: 1;
}
.PaB-scroller--x {
  .PaB-overflowing-start,
  .PaB-overflowing-end {
    top: 0;
    width: 20px;
    height: 100%;
  }
  .PaB-overflowing-start {
    left: 0;
  }
  .PaB-overflowing-end {
    right: 0;
  }
  .PaB-scroll-bar {
    height: 4px;
    width: 100%;
    bottom: 0;
    left: 0;
    right: 0;
    &__handle {
      top: 0;
      height: 4px;
    }
  }
}
.PaB-scroller--y {
  .PaB-overflowing-start,
  .PaB-overflowing-end {
    left: 0;
    right: 0;
    width: 100%;
    height: 20px;
  }
  .PaB-overflowing-start {
    top: 0;
  }
  .PaB-overflowing-end {
    bottom: 0;
  }
  .PaB-scroll-bar {
    width: 4px;
    height: 100%;
    right: 0;
    top: 0;
    bottom: 0;
    &__handle {
      right: 0;
      width: 4px;
    }
  }
}
.PaB-scroller-fade-enter-active {
  transition: opacity 0.3s ease;
}
.PaB-scroller-fade-leave-active {
  transition: opacity 0.2s linear;
}
.PaB-scroller-fade-enter,
.PaB-scroller-fade-leave-to {
  opacity: 0;
}
</style>

<script>
export default {
  props: {
    direction: {
      type: String,
      default: 'x'
    },
    fadeColor: {
      type: String,
      default: '#000000'
    },
    fadeColorStop: {
      type: String,
      default: 'rgba(0, 0, 0, 0)'
    },
    classes: {
      type: Object,
      default: () => {
        return {}
      }
    },
    scrollbar: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      overflowing: {
        start: false,
        end: false,
        length: 0,
        position: 0
      }
    }
  },

  computed: {
    overflowStyle () {
      const style = {
        overflowX: this.direction === 'x' ? 'auto' : 'hidden',
        overflowY: this.direction === 'y' ? 'auto' : 'hidden'
      }

      if (this.direction === 'x') {
        style.paddingBottom = '20px'
        style.marginBottom = '-20px'
      } else {
        style.paddingRight = '20px'
        style.marginRight = '-20px'
      }

      return style
    },
    fadeStartStyle () {
      const direction = this.direction === 'x' ? 'right' : 'bottom'
      return {
        backgroundImage: `linear-gradient(to ${direction}, ${this.fadeColor} 0%, ${this.fadeColorStop} 100%)`
      }
    },
    fadeEndStyle () {
      const direction = this.direction === 'x' ? 'left' : 'top'
      return {
        backgroundImage: `linear-gradient(to ${direction}, ${this.fadeColor} 0%, ${this.fadeColorStop} 100%)`
      }
    },
    scrollBarStyle () {
      let style = {}
      if (this.direction === 'x') {
        style = {
          width: this.overflowing.length,
          left: this.overflowing.position
        }
      } else {
        style = {
          height: this.overflowing.length,
          top: this.overflowing.position
        }
      }

      return style
    }
  },

  created () {
    window.addEventListener('resize', this.checkOverflow)
    this.checkOverflow()
  },

  beforeDestroy () {
    window.removeEventListener('resize', this.checkOverflow)
  },

  methods: {
    checkOverflow: function () {
      const scroller = this.$refs.scroller
      if (!scroller) {
        return
      }
      let scrollStart = scroller.scrollLeft
      let scrollEnd = scroller.offsetWidth + scrollStart
      let scrollLength = scroller.scrollWidth

      this.overflowing.length = `${scroller.offsetWidth / scrollLength * 100}%`
      this.overflowing.position = `${scrollStart / scrollLength * 100}%`

      if (this.direction === 'y') {
        scrollStart = scroller.scrollTop
        scrollEnd = scroller.offsetHeight + scrollStart
        scrollLength = scroller.scrollHeight
        this.overflowing.length = `${scroller.offsetHeight / scrollLength * 100}%`
        this.overflowing.position = `${scrollStart / scrollLength * 100}%`
      }

      if (scrollStart > 0) {
        this.overflowing.start = true
      } else {
        this.overflowing.start = false
      }

      if (scrollEnd < scrollLength) {
        this.overflowing.end = true
      } else {
        this.overflowing.end = false
      }
    }
  }
}
</script>
